"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _editorialArticlePageFragment = require("./editorialArticlePageFragment");
Object.keys(_editorialArticlePageFragment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _editorialArticlePageFragment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _editorialArticlePageFragment[key];
    }
  });
});
var _editorialCategoryOrPageQuery = require("./editorialCategoryOrPageQuery");
Object.keys(_editorialCategoryOrPageQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _editorialCategoryOrPageQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _editorialCategoryOrPageQuery[key];
    }
  });
});
var _editorialCategoryPageFragment = require("./editorialCategoryPageFragment");
Object.keys(_editorialCategoryPageFragment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _editorialCategoryPageFragment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _editorialCategoryPageFragment[key];
    }
  });
});
var _editorialPageFragment = require("./editorialPageFragment");
Object.keys(_editorialPageFragment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _editorialPageFragment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _editorialPageFragment[key];
    }
  });
});
var _personalEditorialCategoryOrPageQuery = require("./personalEditorialCategoryOrPageQuery");
Object.keys(_personalEditorialCategoryOrPageQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _personalEditorialCategoryOrPageQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _personalEditorialCategoryOrPageQuery[key];
    }
  });
});
